import { TOGGLE_LOADER } from '../../constants/appTypes';

const initialState: boolean = false;

interface loaderAction {
  active: boolean;
  type: string;
}

export function loader(state = initialState, action: loaderAction) {
  switch (action.type) {
    case TOGGLE_LOADER:
      state = action.active;
      return state;
    default:
      return state;
  }
}

export default loader;
